export default function TestHighlights() {
	return (
		<div className="bg-background py-2 sm:py-2">
			<div className="mx-auto max-w-2xl px-6 lg:max-w-7xl lg:px-8">
				<h2 className="text-base/7 font-semibold text-orange-600">
					Marky Mock Test
				</h2>
				<p className="mt-2 max-w-lg text-pretty text-4xl font-semibold tracking-tight sm:text-5xl">
					Highlights of Mock Test
				</p>
				<div className="mt-10 grid grid-cols-1 gap-4 sm:mt-16 lg:grid-cols-6 lg:grid-rows-2">
					<div className="relative lg:col-span-3">
						<div className="absolute inset-px rounded-lg bg-white max-lg:rounded-t-[2rem] lg:rounded-tl-[2rem]" />
						<div className="relative flex h-full flex-col overflow-hidden rounded-[calc(theme(borderRadius.lg)+1px)] max-lg:rounded-t-[calc(2rem+1px)] lg:rounded-tl-[calc(2rem+1px)]">
							<div className="flex w-full flex-1 items-center justify-center">
								<video
									className="h-80 object-cover object-left"
									autoPlay
									muted
									loop
									playsInline
								>
									<source
										src="/video/student-marking-omr-sheet.mp4"
										type="video/mp4"
									/>
									Your browser does not support the video tag.
								</video>
							</div>
							<div className="p-10 pt-4">
								<h3 className="text-sm/4 font-semibold text-orange-600">
									India's first
								</h3>
								<p className="mt-2 text-lg font-medium tracking-tight text-gray-950">
									Real OMR Sheet Evaluation System
								</p>
								<p className="mt-2 max-w-lg text-sm/6 text-gray-600">
									Real omr sheet exam experience will increase the confidence
									and accuracy of the students
								</p>
							</div>
						</div>
						<div className="pointer-events-none absolute inset-px rounded-lg shadow ring-1 ring-black/5 max-lg:rounded-t-[2rem] lg:rounded-tl-[2rem]" />
					</div>
					<div className="relative lg:col-span-3">
						<div className="absolute inset-px rounded-lg bg-white lg:rounded-tr-[2rem]" />
						<div className="relative flex h-full flex-col overflow-hidden rounded-[calc(theme(borderRadius.lg)+1px)] lg:rounded-tr-[calc(2rem+1px)]">
							<img
								alt=""
								src="/img/mock-test/marked-omr-sheet.png"
								className="h-80 object-cover object-left lg:object-right"
							/>
							<div className="p-10 pt-4">
								<h3 className="text-sm/4 font-semibold text-orange-600">
									Detailted Report
								</h3>
								<p className="mt-2 text-lg font-medium tracking-tight text-gray-950">
									Subject wise marks
								</p>
								<p className="mt-2 max-w-lg text-sm/6 text-gray-600">
									Get the wrong answer review
								</p>
							</div>
						</div>
						<div className="pointer-events-none absolute inset-px rounded-lg shadow ring-1 ring-black/5 lg:rounded-tr-[2rem]" />
					</div>
					<div className="relative lg:col-span-2">
						<div className="absolute inset-px rounded-lg bg-white lg:rounded-bl-[2rem]" />
						<div className="relative flex h-full flex-col overflow-hidden rounded-[calc(theme(borderRadius.lg)+1px)] lg:rounded-bl-[calc(2rem+1px)]">
							<img
								alt=""
								src="/img/mock-test/cloud-servers.jpg"
								className="h-80 object-cover object-left"
							/>
							<div className="p-10 pt-4">
								<h3 className="text-sm/4 font-semibold text-orange-600">
									Speed
								</h3>
								<p className="mt-2 text-lg font-medium tracking-tight text-gray-950">
									Get your results fast - from cloud
								</p>
								<p className="mt-2 max-w-lg text-sm/6 text-gray-600">
									Get your results in not days, not hours but in minutes. Your
									answer sheets are processed in state of art cloud servers
								</p>
							</div>
						</div>
						<div className="pointer-events-none absolute inset-px rounded-lg shadow ring-1 ring-black/5 lg:rounded-bl-[2rem]" />
					</div>
					<div className="relative lg:col-span-2">
						<div className="absolute inset-px rounded-lg bg-white" />
						<div className="relative flex h-full flex-col overflow-hidden rounded-[calc(theme(borderRadius.lg)+1px)]">
							<img
								alt=""
								src="/img/mock-test/question-paper.png"
								className="h-80 object-cover"
							/>
							<div className="p-10 pt-4">
								<h3 className="text-sm/4 font-semibold text-orange-600">
									Question Paper
								</h3>
								<p className="mt-2 text-lg font-medium tracking-tight text-gray-950">
									Question paper with Answer Key
								</p>
								<p className="mt-2 max-w-lg text-sm/6 text-gray-600">
									Question paper with answer key would be available as soon as
									you finish your test for your revision
								</p>
							</div>
						</div>
						<div className="pointer-events-none absolute inset-px rounded-lg shadow ring-1 ring-black/5" />
					</div>
					<div className="relative lg:col-span-2">
						<div className="absolute inset-px rounded-lg bg-white max-lg:rounded-b-[2rem] lg:rounded-br-[2rem]" />
						<div className="relative flex h-full flex-col overflow-hidden rounded-[calc(theme(borderRadius.lg)+1px)] max-lg:rounded-b-[calc(2rem+1px)] lg:rounded-br-[calc(2rem+1px)]">
							<img
								alt=""
								src="/img/mock-test/expert-teacher.jpg"
								className="h-80 object-cover"
							/>
							<div className="p-10 pt-4">
								<h3 className="text-sm/4 font-semibold text-orange-600">
									Expert Teachers
								</h3>
								<p className="mt-2 text-lg font-medium tracking-tight text-gray-950">
									Best teachers
								</p>
								<p className="mt-2 max-w-lg text-sm/6 text-gray-600">
									Question paper are carefully crafted with expert teachers
								</p>
							</div>
						</div>
						<div className="pointer-events-none absolute inset-px rounded-lg shadow ring-1 ring-black/5 max-lg:rounded-b-[2rem] lg:rounded-br-[2rem]" />
					</div>
				</div>
			</div>
		</div>
	)
}
